import React from 'react';
import * as PropTypes from 'prop-types';

import Slider from '@components/shared/Slider';
import Title from '@components/shared/Title';
import Link from '@components/shared/Link';
import Cure from '@components/Cure/Cure';
import { cureListTypes } from '@constants/common';
import routes from '@constants/routes';

const carouselSettings = () => ({
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 365,
      settings: {
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 768, // $sm-max variables.scss
      settings: {
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 2
      }
    }
  ]
});

const CureRateChoice = ({ condition, list }) => {
  if (!list.length) {
    return null;
  }

  return (
    <div className="condition__list">
      <div className="condition__subheader curerate-choice__subheader">
        <Title className="condition__subtitle" heading="h2" size="md">
          Handpicked by the CureRate team
          {list.length > 4 && (
            <Link
              icon="chevron-right"
              className="condition__link"
              href={routes.cures.list.pattern}
              as={routes.cures.list.path(condition, cureListTypes.handpicked)}
            >
              See all
            </Link>
          )}
        </Title>
      </div>
      <Slider className="curerate-choice__slider" {...carouselSettings()}>
        {list.map(item => (
          <div key={item.slug} className="curerate-choice__item">
            <Cure key={item.slug} cure={item} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

CureRateChoice.propTypes = {
  condition: PropTypes.string.isRequired,
  list: PropTypes.array
};

export default CureRateChoice;
